<div class="calendar-wrapper" *ngIf="calendarOptions">
    <div id="ucCalendar"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenities-calendar-view/amenities-calendar-view.component.html